import { useInfiniteQuery } from "@tanstack/react-query";
import { axiosInstance } from "services/axios/axiosInstance";
const apiURL = "admin/messages/conversations?category=stock";
export const key = ["STOCK_MESSAGES"];
export const useGetStock = (search) =>
  useInfiniteQuery(
    [key, search],
    async ({ pageParam = 1 }) => {
      const { data } = await axiosInstance.get(apiURL, {
        params: {
          per_page: 15,
          page: pageParam,
          search,
        },
      });
      return data;
    },
    {
      staleTime: 1000 * 30,
      onError: (e) => console.log(e),
      getNextPageParam: (nextPage, allPages) => {
        if (nextPage.links.next) return allPages.length + 1;
      },
    }
  );
